import shade from 'polished/lib/color/shade';

import Colors from '../colors';

const pcgGold = `
  background: rgb(189, 162, 99);
  background: linear-gradient(
    90deg,
    ${shade(0.05, Colors.brand.pcg.gold1)} 0%,
    ${shade(0.05, Colors.brand.pcg.gold2)} 50%,
    ${shade(0.05, Colors.brand.pcg.gold1)}
  );
`;

// 10% darker hover on all 3 RGBa values?
const pcgGoldHover = `
  background: rgb(189, 162, 99);
  background: linear-gradient(
    90deg,
    ${shade(0.05, Colors.brand.pcg.gold1)} 0%,
    ${shade(0.05, Colors.brand.pcg.gold2)} 50%,
    ${shade(0.05, Colors.brand.pcg.gold1)}
  ); // TODO: darken RGB values programatically
`;

const pcgBlue = `
  background: rgb(2, 0, 36);
  background: linear-gradient(
    193deg,
    ${shade(0.05, Colors.brand.pcg.darkBlue1)} 0%,
    ${shade(0.05, Colors.brand.pcg.darkBlue2)} 50%,
    ${shade(0.05, Colors.brand.pcg.darkBlue1)}
  );
`;

const pcgBlueRadial = `
  background: rgb(2, 0, 36);
  background: radial-gradient(
    ellipse at 50% 25%,
    rgb(6 34 142 / 50%) 0%,
    rgb(9 38 123 / 50%) 30%,
    rgb(15 34 99 / 50%) 45%,
    rgb(20 30 77 / 50%) 75%,
    rgb(15 17 22 / 50%) 100%
  ),
  linear-gradient(
    205deg,
    #0e1015 0%,
    #0e1e54 50%,
    #0e1015
  );
`;

export default {
  pcgGold,
  pcgGoldHover,
  pcgBlue,
  pcgBlueRadial,
};
